import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

const TEMPLATE = [ [ 'core/paragraph', { placeholder: 'Statement…' } ] ];

export default function Edit() {
	const blockProps = useBlockProps( {
		className: 'brandy-statement-line',
	} );

	const innerBlocksProps = useInnerBlocksProps(
		{ className: 'brandy-statement-line__inner' },
		{ template: TEMPLATE }
	);

	return (
		<div { ...blockProps }>
			<div { ...innerBlocksProps } />
		</div>
	);
}
